import { Action } from '@ngrx/store';
import { BlogCategory, BlogTag } from '../models/blog-post.model';
import { BlogListingModel } from '../models/blog-listing.model';
import { JobListingItem } from '../../jobs-module/models/listing.model';

export enum BlogActionTypes {
  ResetBlogState = '[Blog] Reset Blog State',

  LoadBlogs = '[Blog] Load Blogs',
  LoadBlogsFailed = '[Blog] Load Blogs Failed',
  LoadBlogsSuccessful = '[Blog] Load Blogs Successful',

  AddBlogListingItem = '[Blog] Add Blog Listing Item',
  RemoveBlogListingItem = '[Blog] Remove Blog Listing Item',
  DeleteBlogListingItem = '[Blog] Delete Blog Listing Item',

  DeleteBlogListingItemSuccessful = '[Blog] Successfully Deleted Blog Listing Item',
  DeleteBlogListingItemFailed = '[Blog] Failed Deleting Blog Listing Item',

  DidUpdateBlogPost = '[Blog] Did Update Blog Post',

  LoadBlogCategories = '[Blog] Load Blog Categories',
  LoadBlogCategoriesFailed = '[Blog] Load Blog Categories Failed',
  LoadBlogCategoriesSuccessful = '[Blog] Load Blog Categories Successful',

  LoadBlogTags = '[Blog] Load Blog Tags',
  LoadBlogTagsFailed = '[Blog] Load Blog Tags Failed',
  LoadBlogTagsSuccessful = '[Blog] Load Blog Tags Successful',

  CreateBlogTag = '[Blog] Create Blog Tags',
  CreateBlogTagFailed = '[Blog] Create Blog Tags Failed',
  CreateBlogTagSuccessful = '[Blog] Create Blog Tags Successful',

  CreateListing = '[Blog] Create Blog Listing',
  CreateListingFailed = '[Blog] Create Blog Listing Failed',
  CreateListingSuccessful = '[Blog] Create Blog Listing Successful',

  LoadBlogListing = '[Blog] Load Blog Listing',
  LoadBlogListingFailed = '[Blog] Load Blog Listing Failed',
  LoadBlogListingSuccessful = '[Blog] Load Blog Listing Successful',

  UpdateListing = '[Blog] Update Blog Listing',
  UpdateListingFailed = '[Blog] Update Blog Listing Failed',
  UpdateListingSuccessful = '[Blog] Update Blog Listing Successful',

  SetIsLoading = '[Blog] Set Blog Loading',
}

export class LoadBlogs implements Action {
  readonly type = BlogActionTypes.LoadBlogs;

  constructor(public payload: { unit_id: number }) {}
}

export class LoadBlogsFailed implements Action {
  readonly type = BlogActionTypes.LoadBlogsFailed;

  constructor() {}
}

export class LoadBlogsSuccessful implements Action {
  readonly type = BlogActionTypes.LoadBlogsSuccessful;

  constructor(public payload: { blog_listings: Array<BlogListingModel> }) {}
}

export class AddBlogListingItem implements Action {
  readonly type = BlogActionTypes.AddBlogListingItem;

  constructor(
    public payload: {
      new_listing: BlogListingModel;
      is_blog_listing_valid: boolean;
    }
  ) {}
}

export class RemoveBlogListingItem implements Action {
  readonly type = BlogActionTypes.RemoveBlogListingItem;

  constructor(
    public payload: {
      new_listing: BlogListingModel;
      is_blog_listing_valid: boolean;
    }
  ) {}
}

export class DeleteBlogListingItem implements Action {
  readonly type = BlogActionTypes.DeleteBlogListingItem;

  constructor(public payload: { item: JobListingItem }) {}
}

export class DeleteBlogListingItemSuccessful implements Action {
  readonly type = BlogActionTypes.DeleteBlogListingItemSuccessful;

  constructor() {}
}

export class DeleteBlogListingItemFailed implements Action {
  readonly type = BlogActionTypes.DeleteBlogListingItemFailed;

  constructor() {}
}

export class DidUpdateBlogPost implements Action {
  readonly type = BlogActionTypes.DidUpdateBlogPost;

  constructor(
    public payload: {
      new_listing: BlogListingModel;
      is_valid_blog_info: boolean;
    }
  ) {}
}

export class LoadBlogCategories implements Action {
  readonly type = BlogActionTypes.LoadBlogCategories;

  constructor() {}
}

export class LoadBlogCategoriesFailed implements Action {
  readonly type = BlogActionTypes.LoadBlogCategoriesFailed;

  constructor() {}
}

export class LoadBlogCategoriesSuccessful implements Action {
  readonly type = BlogActionTypes.LoadBlogCategoriesSuccessful;

  constructor(public payload: { categories: Array<BlogCategory> }) {}
}

export class ResetBlogState implements Action {
  readonly type = BlogActionTypes.ResetBlogState;

  constructor(public payload: { new_listing: BlogListingModel }) {}
}

export class LoadBlogTags implements Action {
  readonly type = BlogActionTypes.LoadBlogTags;

  constructor() {}
}

export class LoadBlogTagsFailed implements Action {
  readonly type = BlogActionTypes.LoadBlogTagsFailed;

  constructor() {}
}

export class LoadBlogTagsSuccessful implements Action {
  readonly type = BlogActionTypes.LoadBlogTagsSuccessful;

  constructor(public payload: { tags: Array<BlogTag> }) {}
}

export class CreateBlogTag implements Action {
  readonly type = BlogActionTypes.CreateBlogTag;

  constructor(public payload: { tag: BlogTag }) {}
}

export class CreateBlogTagFailed implements Action {
  readonly type = BlogActionTypes.CreateBlogTagFailed;

  constructor() {}
}

export class CreateBlogTagSuccessful implements Action {
  readonly type = BlogActionTypes.CreateBlogTagSuccessful;

  constructor(
    public payload: {
      blog_tags: Array<BlogTag>;
      selected_listing: BlogListingModel;
      is_blog_info_valid: boolean;
    }
  ) {}
}

export class CreateListing implements Action {
  readonly type = BlogActionTypes.CreateListing;

  constructor(public payload: { listing: BlogListingModel }) {}
}

export class CreateListingFailed implements Action {
  readonly type = BlogActionTypes.CreateListingFailed;

  constructor(public payload: { error: any }) {}
}

export class CreateListingSuccessful implements Action {
  readonly type = BlogActionTypes.CreateListingSuccessful;

  constructor(
    public payload: {
      listings: Array<BlogListingModel>;
      new_listing: BlogListingModel;
    }
  ) {}
}

export class SetIsLoading implements Action {
  readonly type = BlogActionTypes.SetIsLoading;

  constructor(public payload: { isLoading: boolean }) {}
}

export class UpdateListing implements Action {
  readonly type = BlogActionTypes.UpdateListing;

  constructor(public payload: { listing: BlogListingModel }) {}
}

export class UpdateListingFailed implements Action {
  readonly type = BlogActionTypes.UpdateListingFailed;

  constructor(public payload: { error: any }) {}
}

export class UpdateListingSuccesful implements Action {
  readonly type = BlogActionTypes.UpdateListingSuccessful;

  constructor(
    public payload: {
      listings: Array<BlogListingModel>;
      new_listing: BlogListingModel;
    }
  ) {}
}

export class LoadBlogListing implements Action {
  readonly type = BlogActionTypes.LoadBlogListing;

  constructor(public payload: { id: number }) {}
}

export class LoadBlogListingFailed implements Action {
  readonly type = BlogActionTypes.LoadBlogListingFailed;

  constructor(public payload: { error: any }) {}
}

export class LoadBlogListingSuccessful implements Action {
  readonly type = BlogActionTypes.LoadBlogListingSuccessful;

  constructor(
    public payload: {
      new_listing: BlogListingModel;
      is_blog_info_valid: boolean;
      is_valid_blog_listing: boolean;
    }
  ) {}
}

export type BlogActions =
  | LoadBlogs
  | LoadBlogsFailed
  | LoadBlogsSuccessful
  | AddBlogListingItem
  | RemoveBlogListingItem
  | DeleteBlogListingItem
  | DeleteBlogListingItemSuccessful
  | DeleteBlogListingItemFailed
  | DidUpdateBlogPost
  | LoadBlogCategories
  | LoadBlogCategoriesSuccessful
  | LoadBlogCategoriesFailed
  | ResetBlogState
  | LoadBlogTags
  | LoadBlogTagsFailed
  | LoadBlogTagsSuccessful
  | CreateBlogTag
  | CreateBlogTagFailed
  | CreateBlogTagSuccessful
  | CreateListing
  | CreateListingFailed
  | CreateListingSuccessful
  | SetIsLoading
  | UpdateListing
  | UpdateListingFailed
  | UpdateListingSuccesful
  | LoadBlogListing
  | LoadBlogListingFailed
  | LoadBlogListingSuccessful;
